import { Modal as Modal } from "flowbite-react";
export default Modal;
